export default "/images/ef3bb5f5459901699f8b69bacee6a31a.avif";